import ServicePage from '@/pages/services/ServicePage';

const content = {
  eyebrow: 'Integraciones',
  title: 'Sistemas que finalmente conversan.',
  subtitle:
    'Conectamos ERP, plataformas, APIs, medios de pago y servicios externos para eliminar procesos manuales y crear ecosistemas tecnológicos integrados.',
  tags: ['SAP Business One', 'ERP', 'WMS', 'APIs', 'Webhooks', 'Pagos'],
  blocks: [
    {
      icon: 'ri-stack-line',
      title: 'SAP Business One',
      desc: 'Integraciones nativas con SAP Business One mediante Service Layer y DI API.',
    },
    {
      icon: 'ri-database-2-line',
      title: 'ERP y WMS',
      desc: 'Conectamos tu ERP y sistema de gestión de bodegas con tus aplicaciones y canales.',
    },
    {
      icon: 'ri-links-line',
      title: 'APIs REST',
      desc: 'Diseño y consumo de APIs REST para conectar sistemas internos y externos.',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Webhooks',
      desc: 'Eventos en tiempo real que mantienen tus sistemas sincronizados.',
    },
    {
      icon: 'ri-bank-card-line',
      title: 'Medios de pago',
      desc: 'Integración con Transbank, Mercado Pago y Stripe para cobros en línea.',
    },
    {
      icon: 'ri-puzzle-2-line',
      title: 'Integraciones personalizadas',
      desc: 'Soluciones a medida para conectar sistemas propietarios y servicios externos.',
      items: ['Sistemas externos', 'B2B', 'Sincronización'],
    },
  ],
  highlightTitle: 'Menos procesos manuales. Más sistemas conectados.',
  highlightDesc:
    'Cada integración elimina trabajo repetitivo y errores, y libera a tu equipo para enfocarse en lo que genera valor.',
};

export default function Integraciones() {
  return <ServicePage content={content} />;
}